import Config from './config'

const createConfig = (overrides = {}) => ({
  isLocal: false,
  isProduction: true,
  apiBase: '/api/',
  facebookAppId: '276670280470349',
  ...overrides,
})

const production = createConfig()

const stage = createConfig({ facebookAppId: '276670280470349' })

const dev = createConfig({
  isLocal: true,
  isProduction: false,
  facebookAppId: '344237076455690',
})

// initialize config
Config.default(production)
  .environment(/stage.14four/, { ...stage })
  .environment(/kaseydev/, { ...dev })
  .environment(/localhost/, { ...dev })
  .detect()

export default Config
